(() => {
  'use strict';
  const init = (root) => {
    if (root.dataset.quizReady) return;
    const form = root.querySelector('[data-quiz-form]');
    const fields = [...root.querySelectorAll('[data-quiz-fieldset]')];
    const result = root.querySelector('[data-quiz-result]');
    const catalogIntro = root.querySelector('[data-quiz-catalog-intro]');
    const products = root.querySelector('[data-quiz-products]');
    const cards = [...root.querySelectorAll('[data-quiz-product]')];
    const restart = root.querySelector('[data-quiz-restart]');
    const back = root.querySelector('[data-quiz-back]');
    const status = root.querySelector('[data-quiz-status]');
    if (!form || fields.length !== 3 || !result || !products || !restart || !back || !status) return;
    root.dataset.quizReady = 'true';
    let step = 0;
    const focusPanel = (node) => {
      node.focus({preventScroll: true});
      node.scrollIntoView({block: 'start', behavior: 'auto'});
    };
    const selected = (name) => form.querySelector(`input[name="${name}"]:checked`)?.value;
    const showStep = (focus) => {
      form.hidden = false;
      result.hidden = true;
      catalogIntro.hidden = true;
      products.hidden = true;
      restart.hidden = true;
      status.textContent = '';
      fields.forEach((field, index) => {
        field.hidden = index !== step;
        field.disabled = index !== step;
      });
      back.hidden = step === 0;
      root.querySelector('[data-quiz-step]').textContent = String(step + 1);
      root.querySelector('progress').value = step + 1;
      root.querySelector('[data-quiz-next]').hidden = step === 2;
      root.querySelector('[data-quiz-show-result]').hidden = step !== 2;
      if (focus) focusPanel(fields[step].querySelector('legend'));
    };
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!fields[step].querySelector('input:checked')) {
        fields[step].querySelector('input').reportValidity();
        return;
      }
      if (step < 2) {
        step += 1;
        showStep(true);
        return;
      }
      const heat = selected('alegreme_heat');
      const taste = selected('alegreme_taste');
      const dish = selected('alegreme_dish');
      if (!heat || !taste || !dish) return;
      let match = 'habanero';
      if (heat === 'new') match = 'guide';
      else if (taste === 'fruity') match = 'guajillo';
      else if (heat === 'extreme' && taste === 'direct') match = 'carolina';
      form.hidden = true;
      result.hidden = false;
      restart.hidden = false;
      root.querySelector('[data-quiz-guide-title]').hidden = match !== 'guide';
      root.querySelectorAll('[data-quiz-reason]').forEach((node) => { node.hidden = node.dataset.quizReason !== match; });
      root.querySelectorAll('[data-quiz-tip]').forEach((node) => { node.hidden = match === 'guide' || node.dataset.quizTip !== dish; });
      products.hidden = match === 'guide';
      cards.forEach((card) => { card.hidden = card.dataset.quizProduct !== match; });
      const heading = root.querySelector('[data-quiz-result-title]');
      const productTitle = cards.find((card) => card.dataset.quizProduct === match)?.querySelector('[data-quiz-product-title]');
      status.textContent = match === 'guide' ? root.querySelector('[data-quiz-guide-title]').textContent : `${heading.textContent}: ${productTitle?.textContent || ''}`;
      focusPanel(heading);
    });
    back.addEventListener('click', () => {
      if (step > 0) step -= 1;
      showStep(true);
    });
    restart.addEventListener('click', () => {
      form.reset();
      step = 0;
      showStep(true);
    });
    showStep(false);
  };
  const scan = (scope) => {
    if (scope.matches?.('[data-alegreme-quiz]')) init(scope);
    scope.querySelectorAll('[data-alegreme-quiz]').forEach(init);
  };
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
